var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#707070","d":"M0 8.01L8.01 0l8.01 8.01","transform":"rotate(180 8.187 4.182)"}));
}

Arrow.defaultProps = {"className":"arrow","width":"16.727","height":"9.071","viewBox":"0 0 16.727 9.071"};

module.exports = Arrow;

Arrow.default = Arrow;
